import { AllianceLockboxTransaction } from './alliance-lockbox-transaction';
import { Moment } from 'moment';
import moment from 'moment-timezone';
import { LegFiJwtService } from '../../../services/auth/legfi-jwt.service';

export class AllianceLockboxBatch
{
    batch: string;
    total: number;
    items: AllianceLockboxTransaction[];
    date: Moment;

    constructor(ref) {
        const timezone = LegFiJwtService.getTimezone();
        this.date = moment.unix(ref.timestamp).tz(timezone);
        this.batch = ref.batch;
        this.total = ref.total;
        this.items = ref.items.map(item => new AllianceLockboxTransaction(item)).sort((a, b) => {
            return String(a.documentId).localeCompare(b.documentId);
        });
    }

    get checks() {
        return this.items.filter(item => item.documentType !== 'Coupon');
    }

    get hasImportBeenAttempted() {
        return this.checks.filter(item => item.importJob).length > 0;
    }

    get isImportInProgress() {
        return !this.isImportFailed && this.checks.filter(item => item.importJob?.status === 'Queued' || item.importJob?.status === 'Processing').length > 0;
    }

    get isImportFailed() {
        return this.hasImportBeenAttempted && this.checks.filter(item => item.importJob?.status.indexOf('Failed') !== -1).length > 0;
    }

    get isImportComplete() {
        return this.hasImportBeenAttempted && this.checks.filter(item => item.importJob?.status.indexOf('Complete') !== -1).length === this.checks.length;
    }
}
